import { render, staticRenderFns } from "./ManagerInfo.vue?vue&type=template&id=2c140012&"
import script from "./ManagerInfo.vue?vue&type=script&lang=js&"
export * from "./ManagerInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports